import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';

import { EnvironmentService, ErableHttpService, IdUtils } from '@ecm/consumer';

import { MaterialCaptcha } from '../business/material-captcha-model/material-captcha';

@Injectable({
    providedIn: 'root',
})
export class CaptchaService {
    /**
     * tracking bco feature name
     * @type {string}
     */
    private readonly FEATURE_NAME: string = 'ECM_MATERIAL';

    /**
     * tracking bco functionality
     * @type {string}
     */
    private readonly FUNCTIONALITY: string = 'CAPTCHA';

    /**
     * tracking bco service
     * @type {string}
     */
    private readonly SERVICE: string = 'captcha';

    /**
     * tracking bco partner
     * @type {string}
     */
    private readonly PARTNER: string = 'NECMS';

    /**
     * tracking bco page id
     * @type {string}
     */
    private readonly pageId: string;

    public constructor(
        private environmentService: EnvironmentService,
        private httpService: ErableHttpService,
    ) {
        this.pageId = IdUtils.generateRandomId();
    }

    /**
     * Call captcha api to get new captcha
     * @returns {Observable<MaterialCaptcha>}
     * @param apiCaptchaUrl alternative URL for GetCaptcha
     */
    public getCaptcha(apiCaptchaUrl?: string): Observable<MaterialCaptcha> {
        const env = this.environmentService.instant();
        return this.httpService
            .get(apiCaptchaUrl || env.API.CAPTCHA_URL, {
                feature: this.FEATURE_NAME,
                pageId: this.pageId,
                functionality: this.FUNCTIONALITY,
                partner: this.PARTNER,
                service: this.SERVICE,
                force: true,
            })
            .pipe(
                map((response: any) => {
                    return new MaterialCaptcha(response.captcha || response);
                }),
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => error);
                }),
            );
    }
}
